/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Email_FailedInputs */

const en_consumer_declaration_email_failed = /** @type {(inputs: Consumer_Declaration_Email_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your declaration is recorded. Email delivery could not be completed; download this receipt now.`)
};

const de_consumer_declaration_email_failed = /** @type {(inputs: Consumer_Declaration_Email_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre Erklärung ist gespeichert. Die E-Mail konnte nicht zugestellt werden; laden Sie diese Bestätigung jetzt herunter.`)
};

const fr_consumer_declaration_email_failed = /** @type {(inputs: Consumer_Declaration_Email_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre déclaration est enregistrée. L’e-mail n’a pas pu être envoyé ; téléchargez ce reçu maintenant.`)
};

const es_consumer_declaration_email_failed = /** @type {(inputs: Consumer_Declaration_Email_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu declaración está registrada. No se pudo enviar el correo; descarga ahora este justificante.`)
};

const it_consumer_declaration_email_failed = /** @type {(inputs: Consumer_Declaration_Email_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La dichiarazione è registrata. L’e-mail non è stata consegnata; scarica ora questa ricevuta.`)
};

const nl_consumer_declaration_email_failed = /** @type {(inputs: Consumer_Declaration_Email_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je verklaring is opgeslagen. De e-mail kon niet worden bezorgd; download dit bewijs nu.`)
};

const pl_consumer_declaration_email_failed = /** @type {(inputs: Consumer_Declaration_Email_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oświadczenie zapisano. Nie udało się dostarczyć e-maila; pobierz potwierdzenie teraz.`)
};

const fi_consumer_declaration_email_failed = /** @type {(inputs: Consumer_Declaration_Email_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmoituksesi on tallennettu. Sähköpostia ei voitu toimittaa; lataa kuitti nyt.`)
};

const da_consumer_declaration_email_failed = /** @type {(inputs: Consumer_Declaration_Email_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Din erklæring er gemt. E-mailen kunne ikke leveres; download kvitteringen nu.`)
};

const sv_consumer_declaration_email_failed = /** @type {(inputs: Consumer_Declaration_Email_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Din förklaring är sparad. E-postmeddelandet kunde inte levereras; ladda ned kvittot nu.`)
};

/**
* | output |
* | --- |
* | "Your declaration is recorded. Email delivery could not be completed; download this receipt now." |
*
* @param {Consumer_Declaration_Email_FailedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_email_failed = /** @type {((inputs?: Consumer_Declaration_Email_FailedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Email_FailedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_email_failed(inputs)
	if (locale === "fr") return fr_consumer_declaration_email_failed(inputs)
	if (locale === "es") return es_consumer_declaration_email_failed(inputs)
	if (locale === "it") return it_consumer_declaration_email_failed(inputs)
	if (locale === "nl") return nl_consumer_declaration_email_failed(inputs)
	if (locale === "pl") return pl_consumer_declaration_email_failed(inputs)
	if (locale === "fi") return fi_consumer_declaration_email_failed(inputs)
	if (locale === "da") return da_consumer_declaration_email_failed(inputs)
	if (locale === "sv") return sv_consumer_declaration_email_failed(inputs)
	return en_consumer_declaration_email_failed(inputs)
});